import React from "react";
import banner from "../assets/images/banner.webp";
import FormComponent from "./form-component";

const BannerComponent = () => {
  return (
    <>
      <section className="banner pb-0" style={{ background: banner }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-12">
              <div className="bnrcontent">
                <h1>Shape your career</h1>
                <h2>
                  with ICICI Bank <br /> Aspire Programme
                </h2>
                <ul>
                  <li>
                    Comprehensive
                    <br />
                    2-month training
                  </li>
                </ul>
                <ul>
                  <li>Guaranteed placement</li>
                </ul>
                <ul>
                  <li>CTC up to ₹5 Lakh</li>
                </ul>
              </div>
            </div>
            <FormComponent></FormComponent>
          </div>
        </div>
      </section>
    </>
  );
};

export default BannerComponent;
